export default __webpack_public_path__ + "static/media/screencapture-doctor-61229-web-app-2021-10-02-22_31_34.d6345976.png";